var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Autocomplete, TextField } from '@mui/material';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { SPORT_EVENTS_SHORT } from 'common/graphql/queries/sportEvent/sportEventsShort';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
var ActivityValidationSportEventAutocomplete = function (_a) {
    var sportEventId = _a.sportEventId, setSportEventId = _a.setSportEventId, validationLevel = _a.validationLevel, className = _a.className, limitToSportEventIds = _a.limitToSportEventIds;
    var t = useTranslation().t;
    var _b = useQuery(SPORT_EVENTS_SHORT), sportEventsData = _b.data, loading = _b.loading;
    var sportEvents = (sportEventsData === null || sportEventsData === void 0 ? void 0 : sportEventsData.sportEvents) || [];
    var formatSportEvents = function (sportEvents) {
        var sportEventsFormatted = sportEvents.map(function (sportEvent) {
            var _a;
            return {
                label: ((_a = sportEvent.mainSettings) === null || _a === void 0 ? void 0 : _a.displayName) || sportEvent.name,
                id: sportEvent.id
            };
        });
        if (limitToSportEventIds && limitToSportEventIds.length > 0) {
            sportEventsFormatted = sportEventsFormatted.filter(function (o) { return limitToSportEventIds.includes(o.id); });
        }
        return sportEventsFormatted;
    };
    var _c = useState(null), value = _c[0], setValue = _c[1];
    useEffect(function () {
        var _a;
        if ((sportEventsData === null || sportEventsData === void 0 ? void 0 : sportEventsData.sportEvents) && ((_a = sportEventsData === null || sportEventsData === void 0 ? void 0 : sportEventsData.sportEvents) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var sportEventsFormatted = formatSportEvents(sportEvents);
            if (sportEventId) {
                setValue(sportEventsFormatted.filter(function (se) { return se.id === sportEventId; })[0] || null);
            }
            else {
                if (sportEventsFormatted.length === 1) {
                    setValue(sportEventsFormatted[0]);
                }
            }
        }
    }, [sportEventsData]);
    useEffect(function () {
        if (value)
            setSportEventId(value.id);
    }, [value]);
    if (validationLevel !== ActivityValidationLevels.SportEvent)
        return null;
    return (_jsx(Autocomplete, { className: className, "aria-required": true, value: value, loading: loading, disablePortal: true, options: formatSportEvents(sportEvents), renderInput: function (params) { return (_jsx(TextField, __assign({ name: "address", label: t("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435") }, params), void 0)); }, onInputChange: function (event, newInputValue, reason) {
            if (reason === 'clear') {
                setSportEventId(undefined);
            }
        }, onChange: function (event, newValue) {
            setValue(newValue);
        }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, sx: {
            '& .MuiOutlinedInput-root': {
                height: '56px',
                paddingTop: '10px',
                paddingBottom: '10px'
            },
            '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
            }
        } }, void 0));
};
export default ActivityValidationSportEventAutocomplete;
